import React from 'react';
import { url } from '../../../utils/variables';
import ImagePickerModal from '../../master/ImagePickerModal';
import { useTranslation } from 'react-i18next';
import ImageZoom from '../../master/ImageZoom';
import { useState } from 'react';
import Modal from '../../master/Modal';

export default function UploadDamageImages({ attachments, uploadDoc, changeStep }) {

    const damageImages = attachments.filter(img => img.filename.includes('damage_image'));
    const { t } = useTranslation();
    const [showImage , setShowImage] = useState(null);
    return (
        <>
        <div className='complete-content crashImages'>
            {/* <div className='title-box'>
                <div className='title-parent'>
                    <div className='dot' />
                    <p>مواضع و قطعات خسارت دیده</p>
                </div>
                <i className='fas fa-image' />
            </div>
            <div className='image-parent'>
                {
                    damagedImages.map(img => (
                        <div className='img' key={img.id}>
                            <img src={`${url}/files?uid=${img.uid}&width=150&height=150`} alt='img' />
                        </div>
                    ))
                }
                <div className='img'>
                    <ImagePickerModal
                        disableGallery
                        renderBtn={
                            <div className='defaultImage' />
                        }
                        upload={(image, done) => uploadDoc(image, `damaged_image${damagedImages.length + 1}`, done)}
                    />
                </div>
            </div> */}
            <div className='title-box'>
                <div className='title-parent'>
                    <div className='dot' />
                    <p>{t('The scene of the accident')}<small>({t('Optinal')})</small></p>
                </div>
                <i className='fas fa-image' />
            </div>
            <div className='image-parent'>
                {
                    damageImages.map(img => (
                        <div className='img' key={img.id}>
                            <img src={`${url}/files?uid=${img.uid}&width=150&height=150`} alt='img' onClick={()=> setShowImage(img.uid)}/>
                        </div>
                    ))
                }
                <div className='img'>
                    <ImagePickerModal
                        renderBtn={
                            <div className='defaultImage' data-content={t('Add')} />
                        }
                        upload={(image, done) => uploadDoc(image, `damage_image${damageImages.length + 1}`, done)}
                    />
                </div>
            </div>
            <div className='nav-button-parent'>
                <button className='navButton mr5' onClick={() => changeStep(5)}>
                    {t('Next step')}
                    <i className='fas fa-chevron-down' />
                </button>
                <button className='navButton prev ml5' onClick={() => changeStep(3)}>
                    {t('Prev step')}
                    <i className='fas fa-chevron-up' />
                </button>
            </div>
        </div>
        <Modal visible={showImage}>
            <div className='image-modal'>
                <i className='fas fa-times'
                    onClick={() => setShowImage(null)}
                />
                <ImageZoom imgUid={showImage}/>
            </div>
        </Modal>
        </>
    );

}
